var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShow = function SvgShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18.952 15.067a3.952 3.952 0 1 1-7.904-.002 3.952 3.952 0 0 1 7.904.002Z",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.998 24.194c4.76 0 9.113-3.422 11.565-9.127-2.452-5.706-6.805-9.128-11.565-9.128h.005c-4.76 0-9.114 3.422-11.566 9.127 2.452 5.705 6.806 9.128 11.566 9.128h-.005Z",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgShow;